<div class="dialog">
    <h6>Enter New Option</h6>
    <div class="custom-form mt-4" [formGroup]="newCertificateForm" *ngIf="!isNewCertificateAdded">
        <input type="text" formControlName="new_certificate_name">
    </div>
    <div class="button mt-4">
        <button class="orange mr-3" (click)="cancel()">Cancel</button>
        <button class="white ml-3" (click)="submit()">Save</button>
    </div>
</div>